export default __webpack_public_path__ + "static/media/Young Adult.d04c6bac.png";